<template lang="pug">
  div.registry.operators
    e-toolbar(
      :items="items"
      @deleteItems="deleteItems"
      :hideRemoveButton="true"
      :showTotal="true"
      :showExport="true"
      :endpointExport="getExportEndpoint"
    )
      template(v-slot:filter)
        actions-filter(
          v-model="filters"
          @applyFilter="applyFilters"
        )
    e-table(
      :items="items"
      @deleteItem="deleteItem"
      @editItem="editItem"
      :showCheckbox="false"
    )
    
    router-view
</template>

<script>
  import { export_document, tko } from '@/api/api-endpoints'
  import tableMixin               from '../../../components/table/table-mixin.js'
  import ActionsFilter            from '../components/filters/actions-filter'
  import url                      from '@/utils/url'
  
  export default {
    name: 'Operators',
    mixins:  [tableMixin],
    data() {
      return {
        filters: {
          actions: []
        }
      }
    },
    created() {
      if (this.$route?.query?.actions) {
        this.$set(this.filters, 'actions', this.$route.query.actions)
      }
    },
    components: { ActionsFilter },
    methods: {
      getEndpoint(route) { return tko.operators(route) },
      getDeleteUrl(id) { return tko.operatorDelete(id) },
      getExportEndpoint() { return export_document.tkoOperator(this.$route) },
      applyFilters() {
        let route = url.getRoute(this.$route)
        route.query.actions = this.filters.actions
        if (!route.query.actions || !route.query.actions?.length) {
          delete route.query.actions
        }
        this.$router.push(route)
      },
    }
  }
</script>
